if (!customElements.get('comparison-table-mobile')) {
  customElements.define(
    'comparison-table-mobile',
    class ComparisonTableMobile extends HTMLElement {
      constructor() {
        super();
        this.flickity = null;
      }

      connectedCallback() {
        this.sliderNode = this.querySelector('.comparison-table__mobile-slider');
        if (!this.sliderNode) return;

        this.initFlickity();
      }

      initFlickity() {
        const checkFlickity = setInterval(() => {
          if (window.Flickity) {
            clearInterval(checkFlickity);
            this.setupFlickity();
          }
        }, 100);

        setTimeout(() => clearInterval(checkFlickity), 3000);
      }

      setupFlickity() {
        const options = {
          cellAlign: 'center',
          contain: false,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: true,
          percentPosition: true
        };

        this.flickity = new window.Flickity(this.sliderNode, options);

        // Force a resize after a short delay for stability
        setTimeout(() => this.flickity.resize(), 500);

        // Content synchronization
        this.flickity.on('select', () => {
          const selectedCell = this.flickity.selectedElement;
          const index = parseInt(selectedCell.dataset.index);
          this.updateContent(index);
        });

        // Navigation
        const prevBtn = this.querySelector('.slider-button--prev');
        const nextBtn = this.querySelector('.slider-button--next');

        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.flickity.previous();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.flickity.next();
          });
        }

        // Trigger initial update
        this.updateContent(0);
      }

      updateContent(index) {
        const allInfo = this.querySelectorAll('.comparison-table__dynamic-info');
        allInfo.forEach((info) => {
          if (parseInt(info.dataset.index) === index) {
            info.style.display = 'block';
            info.style.opacity = '0';
            setTimeout(() => {
              info.style.transition = 'opacity 0.3s ease';
              info.style.opacity = '1';
            }, 10);
          } else {
            info.style.display = 'none';
          }
        });
      }
    }
  );
}
